import { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Stack,
  Typography,
  Select,
  MenuItem,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  IconButton,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Box } from '@mui/system';
import { Link as RouterLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import inputValidation from '../../utils/globalValidation';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import aadharBackDummy from './dummy/aadharBackDummy.png';
import panCardDummy from './dummy/panCardDummy.jpg';
import cancelChequeDummy from './dummy/cancelChequeDummy.png';
import gstRegistrationCertificate from './dummy/GSTRegistrationCertificate.jpg';
// import gstin from './dummy/gstin.pdf';
import CustomDate from '../../components/CustomDate';
import incorporationCertificate from './dummy/certificateIncorporation.jpg';
import logoDummy from './dummy/logoDummy.png';
import ErrorDialog from '../Global/ErrorDialog';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  getCityData,
  getDocsTypesData,
  getPartnerCompanyType,
  getPartnerTypesData,
  getStateData,
  saveApiData,
  savefileApiData,
  setCityData
} from '../../store/Slice/Global/GlobalSlice';
import CustomSelect from '../../components/CustomSelect';
import CustomInput from '../../components/CustomInput';
import { OnboardingApi } from '../../utils/Apis';
import { setApiError, setApiSuccess } from '../../store/Slice/Error/ErrorSlice';
import { isValidValue } from '../../utils/CommonFunction';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { VerifyFileData } from '../../store/Slice/Onboarding/OnboardingSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function AddEditOnBoarding() {
  const [activeStep, setActiveStep] = useState(0);
  const [partnerType1, setPartnerType1] = useState('');
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [aadharBackPreview, setAadharBackPreview] = useState(aadharBackDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);
  const [uploadPhoto, setUploadPhoto] = useState(); // uploaded image file frontside
  const [uploadImageFileFront, setUploadImageFileFront] = useState(null); // uploaded image file frontside
  const [uploadImageFileBack, setUploadImageFileBack] = useState(null); // uploaded image file backside
  const [uploadPanImage, setUploadPanImage] = useState();
  const [uploadChequeImage, setUploadChequeImage] = useState();
  const [errorOpen, setErrorOpen] = useState(false);
  const [gstImage, setGstImage] = useState();
  const [panPreview1, setPanPreview1] = useState(panCardDummy);
  const [gstPreview, setGstPreview] = useState(gstRegistrationCertificate);
  const [gstPreviewtype1, setGstPreviewtype1] = useState('');
  const [incorporationPreviewtype1, setIncorporationPreviewtype1] = useState('');
  const [panPreview1type1, setPanPreview1type1] = useState('');
  const [chequePreview1type1, setChequePreview1type1] = useState('');
  const [panPreviewtype1, setPanPreviewtype1] = useState('');
  const [chequePreviewtype1, setChequePreviewtype1] = useState('');
  const [logoPreviewtype1, setLogoPreviewtype1] = useState('');
  const [photoPreviewtype1, setPhotoPreviewtype1] = useState('');
  const [aadharFrontPreviewtype1, setAadharFrontPreviewtype1] = useState('');
  const [incorporationPreview, setIncorporationPreview] = useState(incorporationCertificate);
  const [incorporationUploadComp, setIncorporationUploadComp] = useState();
  const [uploadPanImageCompany, setUploadPanImageCompany] = useState();
  const [chequePreview1, setChequePreview1] = useState(cancelChequeDummy);
  const [uploadChequeCompany, setUploadChequeCompany] = useState();
  const [logoPreview, setLogoPreview] = useState(logoDummy);
  const [logoUpload, setLogoUpload] = useState();
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page
  const [otpOpen, setOtpOpen] = useState(false);
  const [otpMobileOpen, setOtpMobileOpen] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [otpMobileValue, setOtpMobileValue] = useState('');
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  const [aadharModalOpen, setAadharModalOpen] = useState(false);
  const [aadharNumber, setAadharNumber] = useState('');
  const [aadharOtpValue, setAadharOtpValue] = useState('');
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadharOtpLoading, setAadharOtpLoading] = useState(false);

  const [panModalOpen, setPanModalOpen] = useState(false);
  const [panNumber, setPanNumber] = useState('');
  const [panName, setPanName] = useState('');
  const [panDob, setPanDob] = useState('');
  const [uploadPanForVerification, setUploadPanForVerification] = useState(null);
  const [panPreviewForVerification, setPanPreviewForVerification] = useState('');
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [panVerificationLoading, setPanVerificationLoading] = useState(false);
  const [verifyMail, setVerifyMail] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);

  const { rowId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { stateDrop, CityDrop, DocsTypesDrop, PartnerStatusDrop, PartnerCompanyTypesDrop } =
    useGlobalSelector();
  const { ReportingManagerListData } = useOnboardingSelector();

  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    setError,
    trigger,
    formState: { errors }
  } = useForm({
    mode: 'onBlur', // Add this to validate on blur
    defaultValues: {
      partnerName: '',
      dob: '',
      mobile: '',
      emailAddress: '',
      loanTypeId: '',
      misMonth: ''
    }
  });

  const relationshipManager = watch('relationshipManager');
  const emailAddress = watch('emailAddress');
  const mobile = watch('mobile');

  useEffect(() => {
    if (!emailAddress) {
      setVerifyMail(false);
      return;
    }
    const result = inputValidation({ target: { value: emailAddress } }, 'EMAIL');
    setVerifyMail(result === true);
  }, [emailAddress]);

  useEffect(() => {
    if (!mobile) {
      setVerifyMobile(false);
      return;
    }
    const result = inputValidation({ target: { value: mobile } }, 'MOBILE');
    setVerifyMobile(result === true);
  }, [mobile]);

  useEffect(() => {
    const list = ReportingManagerListData || [];
    const selected = list.find((u) => String(u.userId) === String(relationshipManager));
    const name = selected ? selected.fullName || selected.email || '' : '';
    sessionStorage.setItem('relationshipManagerSelected', name);
  }, [relationshipManager, ReportingManagerListData]);

  const stateSelected = watch('provinceId') || null;

  useEffect(() => {
    if (PartnerStatusDrop && PartnerStatusDrop.length > 0) {
      const selectedType = location?.state?.partnerType;
      const selectedTypeId = location?.state?.typeId;

      if (selectedTypeId) {
        setPartnerType1(selectedTypeId);
      } else if (selectedType === 'company') {
        const companyType = PartnerStatusDrop.find(
          (item) =>
            item?.label?.toLowerCase().includes('company') ||
            item?.label?.toLowerCase().includes('corporate') ||
            item?.value !== 66
        );
        setPartnerType1(companyType?.value || PartnerStatusDrop[0]?.value);
      } else if (selectedType === 'individual') {
        const individualType = PartnerStatusDrop.find(
          (item) => item?.value === 66 || item?.label?.toLowerCase().includes('individual')
        );
        setPartnerType1(individualType?.value || 66);
      } else {
        const individualType = PartnerStatusDrop.find((item) => item?.value === 66);
        setPartnerType1(individualType?.value || PartnerStatusDrop?.[0]?.value);
      }
    }
  }, [PartnerStatusDrop, location?.state]);

  const selectedPartnerTypeLabel =
    PartnerStatusDrop?.find((item) => String(item?.value) === String(partnerType1))?.label ||
    (partnerType1 === 66 ? 'Individual' : 'Company');

  // File upload functions UI
  const handleFileUpload = (e, setPreview, setUploadImage, setLocaltype) => {
    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

    if (!file) return;

    setLocaltype(file.name.split('.').pop());
    setUploadImage(file);
    setPreview(URL.createObjectURL(file));
  };

  useEffect(() => {}, [uploadPhoto]);

  function onDocumentLoadSuccess({ numPages }) {
    setPageNumber(1);
  }

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e, setPreview, setUploadImage, setLocaltype) => {
    e.preventDefault();
    handleFileUpload(e, setPreview, setUploadImage, setLocaltype);
  };

  //  city api
  const handleGetCity = useCallback(
    (optionVal) => {
      if (!optionVal) {
        dispatch(setCityData([])); // city data
        setValue('districtId', null);
        return '';
      }
      const data = {
        stateId: optionVal,
        searchLiteral: ''
      };
      dispatch(getCityData(data)); // fetch city data
    },
    [LoginData?.companyId, LoginData?.userId] // dependencies
  );

  const handleNextStep = async () => {
    if (partnerType1 === 66) {
      const isValid = await trigger([
        'partnerName',
        'fathersName',
        'dob',
        'mobile',
        'emailAddress',
        'address',
        'provinceId',
        'districtId'
      ]);

      const dobVal = watch('dob');
      if (!isValidValue(dobVal)) {
        setError('dob', {
          type: 'manual',
          message: 'Date of Birth is required'
        });
        return;
      } else if (dobVal) {
        const birthDate = new Date(dobVal);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          setError('dob', {
            type: 'manual',
            message: 'Age should be greater than 18 years'
          });
          return;
        }
      }

      if (!isMobileVerified) {
        dispatch(setApiError('Please verify your mobile number before proceeding'));
        return;
      }
      if (!isEmailVerified) {
        dispatch(setApiError('Please verify your email address before proceeding'));
        return;
      }

      if (!isValid) return;
    } else {
      const isValid = await trigger([
        'companyName',
        'mobile',
        'emailAddress',
        'address',
        'provinceId'
      ]);
      if (!isMobileVerified) {
        dispatch(setApiError('Please verify your mobile number before proceeding'));
        return;
      }
      if (!isEmailVerified) {
        dispatch(setApiError('Please verify your email address before proceeding'));
        return;
      }
      if (!isValid) return;
    }

    setActiveStep(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onSubmit = useCallback(
    async (data) => {
      if (partnerType1 === 66) {
        if (!isValidValue(data?.dob)) {
          setError('dob', {
            type: 'manual', // 'manual' indicates programmatically set
            message: 'Date of Birth is required' // error message shown to user
          });
          return;
        } else if (data?.dob) {
          const birthDate = new Date(data?.dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          if (age < 18) {
            setError('dob', {
              type: 'manual', // 'manual' indicates programmatically set
              message: 'Age should be greater than 18 years' // error message shown to user
            });
            return ''; // Age is less than 18
          }
        }
      }
      const finalData = {
        ...data, // mobile, "emailAddress", address, provinceId, districtId, etc.
        partnerName: data?.partnerName || data?.companyName,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        typeId: partnerType1,
        countryId: 101,
        reportingManagerId: LoginData?.userId,

        // 🔹 match backend’s successful payload
        isSignUpFlow: true,
        isAgreementChecked: true,
        accessType: 'LEAD',
        isNextUserAllowed: false,
        isPartnerLoginAllowed: false,

        // 🔹 make sure this goes
        relationshipManager: data?.relationshipManager ?? null
      };

      try {
        const res = await dispatch(saveApiData(OnboardingApi?.onboardCreatePartner, finalData));
        if (res?.data?.status === 'success') {
          const PartnerId = res?.data?.partnerId;
          const CompanyIds = res?.data?.companyId;

          if (res?.data.isPartnerAlreadyExist) {
            dispatch(setApiError('Mobile Number Already Available'));
            return;
          }

          // Reusable document upload function
          const uploadDocument = async (file, typeCode, fieldName) => {
            if (!file || file.size <= 0) return;

            try {
              const formData = new FormData();
              formData.append('partnerId', PartnerId);
              formData.append('companyId', CompanyIds);

              const docType = DocsTypesDrop.find((item) => item.typeCode === typeCode);
              if (docType) formData.append('documentTypeId', docType.value);

              formData.append(fieldName, file);
              const token = LoginData?.jwt;
              const result = await dispatch(
                savefileApiData(`${OnboardingApi?.onboardDocUpload}`, formData, token)
              );
              console.log('result of files', result);
              if (result && result?.status === 'success') {
                console.log(`${typeCode} upload successful:`, result);
              } else {
                console.error(`${typeCode} upload failed:`, result);
              }
            } catch (error) {
              console.error(`Error uploading ${typeCode}:`, error);
            }
          };

          const documents = [
            { file: uploadPhoto, typeCode: 'USER IMAGE', fieldName: 'userImage' },
            { file: uploadImageFileFront, typeCode: 'AADHAR CARD', fieldName: 'aadharFront' },
            { file: uploadImageFileBack, typeCode: 'AADHAR CARD', fieldName: 'aadharBack' },
            { file: uploadPanImage, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeImage, typeCode: 'CHEQUE', fieldName: 'cheque' },
            { file: logoUpload, typeCode: 'COMPANY_LOGO', fieldName: 'companyLogo' },
            { file: gstImage, typeCode: 'GSTIN', fieldName: 'gstInDocument' },
            {
              file: incorporationUploadComp,
              typeCode: 'INCORPORATION_CERTIFICATE',
              fieldName: 'incorporationCertificate'
            },
            { file: uploadPanImageCompany, typeCode: 'PAN CARD', fieldName: 'panCard' },
            { file: uploadChequeCompany, typeCode: 'CHEQUE', fieldName: 'cheque' }
          ];

          await Promise.all(
            documents.map((doc) => uploadDocument(doc?.file, doc?.typeCode, doc?.fieldName))
          );

          localStorage.setItem('partnerId', PartnerId);
          dispatch(setApiSuccess('Partner created successfully'));
          navigate('/onboarding');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [
      LoginData,
      partnerType1,
      uploadPhoto,
      uploadImageFileFront,
      uploadImageFileBack,
      uploadPanImage,
      uploadChequeImage,
      logoUpload,
      gstImage,
      incorporationUploadComp,
      uploadPanImageCompany,
      uploadChequeCompany
    ]
  );

  const handlePartnerType = (e) => {
    reset();
    setPartnerType1(e.target.value);
    setPhotoPreview(photoDummy);
    setAadharFrontPreview(aadharFrontDummy);
    setAadharBackPreview(aadharBackDummy);
    setPanPreview(panCardDummy);
    setChequePreview(cancelChequeDummy);
    setGstPreview(gstRegistrationCertificate);
    setPanPreview1(panCardDummy);
    setChequePreview1(cancelChequeDummy);
    setIncorporationPreview(incorporationCertificate);
    setLogoPreview(logoDummy);
  };

  const getStateList = () => {
    const data = {
      countryId: 101
    };
    dispatch(getStateData(data));
  };

  useEffect(() => {
    dispatch(getPartnerTypesData());
    dispatch(getPartnerCompanyType());
    dispatch(getDocsTypesData());
    getStateList();
  }, []);

  async function handleEmailSend() {
    if (!emailAddress) {
      dispatch(setApiError('Please enter email'));
      return;
    }
    const payload = { email: emailAddress };
    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardEmailSend, payload));
      if (result?.status === 'success') {
        setOtpOpen(true);
        dispatch(setApiSuccess('OTP sent to your mail id'));
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleEmailVerifyOtp() {
    if (!otpValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      email: emailAddress,
      otp: otpValue
    };

    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardEmailVerify, payload));

      if (result?.status === 'success') {
        setIsEmailVerified(true);
        setOtpOpen(false);
        setOtpValue('');
        dispatch(setApiSuccess('Email verified successfully'));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOtpLoading(false);
    }
  }

  async function handleMobileSend() {
    if (!mobile) {
      dispatch(setApiError('Please enter mobile number'));
      return;
    }
    const payload = { mobileNumber: mobile };
    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardMobileSend, payload));
      if (result?.success === true) {
        setOtpMobileOpen(true);
        dispatch(setApiSuccess('OTP sent to your mobile number'));
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function handleMobileVerifyOtp() {
    if (!otpMobileValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      mobileNumber: mobile,
      otp: otpMobileValue
    };

    try {
      const result = await dispatch(saveApiData(OnboardingApi?.onBoardMobileVerify, payload));

      if (result?.success === true) {
        setIsMobileVerified(true);
        setOtpMobileOpen(false);
        setOtpMobileValue('');
        dispatch(setApiSuccess(result?.message || 'Mobile verified successfully'));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setOtpLoading(false);
    }
  }

  async function handleAadharSend() {
    if (!aadharNumber) {
      dispatch(setApiError('Please enter Aadhar number'));
      return;
    }
    if (!uploadImageFileFront) {
      dispatch(setApiError('Please upload Aadhar document'));
      return;
    }

    setAadharOtpLoading(true);

    try {
      const formData = new FormData();
      formData.append('aadhaar_no', aadharNumber);
      formData.append('aadhaar_doc', uploadImageFileFront);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      const result = await dispatch(savefileApiData(OnboardingApi?.onBoardAadharSend, formData));

      if (result?.success === true) {
        setOtpGenerated(true);
        dispatch(setApiSuccess('OTP sent to your registered mobile'));
      } else {
        dispatch(setApiError(result?.message || 'Failed to send OTP'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error sending OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  async function handleAadharVerifyOtp() {
    if (!aadharOtpValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setAadharOtpLoading(true);

    const payload = {
      otp: aadharOtpValue,
      ref_id: 46538513,
      client_id: 'pb',
      userId: 'system'
    };

    try {
      const result = await dispatch(VerifyFileData(OnboardingApi?.onBoardAadharVerify, payload));

      if (result?.success === true) {
        setIsAadharVerified(true);
        setAadharModalOpen(false);
        setAadharOtpValue('');
        dispatch(setApiSuccess(result?.message || 'Aadhar verified successfully'));
      } else {
        dispatch(setApiError(result?.message || 'OTP verification failed'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  async function handlePanVerify() {
    if (!panNumber) {
      dispatch(setApiError('Please enter PAN number'));
      return;
    }
    if (!panName) {
      dispatch(setApiError('Please enter full name'));
      return;
    }
    if (!panDob) {
      dispatch(setApiError('Please enter date of birth'));
      return;
    }
    if (!uploadPanForVerification) {
      dispatch(setApiError('Please upload PAN document'));
      return;
    }

    setPanVerificationLoading(true);

    try {
      const formData = new FormData();
      formData.append('pan_no', panNumber.toUpperCase());
      formData.append('name', panName.toUpperCase());
      formData.append('dob', panDob);
      formData.append('pan_doc', uploadPanForVerification);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      const result = await dispatch(savefileApiData(OnboardingApi?.verifyPan, formData));

      if (result?.success === true) {
        setIsPanVerified(true);
        setPanModalOpen(false);

        const previewUrl = URL.createObjectURL(uploadPanForVerification);

        setPanPreview(previewUrl);
        setPanPreviewtype1(uploadPanForVerification.name.split('.').pop());
        setUploadPanImage(uploadPanForVerification);

        dispatch(setApiSuccess(result?.message || 'PAN verified successfully'));

        setPanNumber('');
        setPanName('');
        setPanDob('');
        setUploadPanForVerification(null);
        setPanPreviewForVerification('');
      } else {
        dispatch(setApiError(result?.message || 'PAN verification failed'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying PAN'));
    } finally {
      setPanVerificationLoading(false);
    }
  }

  return (
    <Page title="Partner Management System || On Boarding">
      <Container maxWidth="xl" sx={{ pb: 6, pt: 2 }}>
        {/* Header Row: Icon, Title & Breadcrumbs */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          sx={{ mb: 3.5, gap: 2 }}
        >
          {/* Left Title & Icon */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '12px',
                bgcolor: '#e0f2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0284c7'
              }}
            >
              <PersonAddOutlinedIcon sx={{ fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: '#0f172a',
                  fontSize: { xs: '20px', sm: '24px' },
                  letterSpacing: '-0.3px',
                  mb: 0.25
                }}
              >
                {rowId ? 'Edit Partner' : 'Add New Partner'}
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '13px' }}>
                Register and onboard a new partner with document verification and details.
              </Typography>
            </Box>
          </Stack>

          {/* Right Breadcrumbs */}
          <Box>
            <BrudCrumbs />
          </Box>
        </Stack>

        {/* Selected Partner Type Display */}
        <Card
          sx={{
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            p: 2.5,
            mb: 3,
            bgcolor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '10px',
                bgcolor: '#e0f2fe',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#0284c7'
              }}
            >
              {partnerType1 === 66 ? (
                <PersonIcon sx={{ fontSize: 24 }} />
              ) : (
                <ApartmentIcon sx={{ fontSize: 24 }} />
              )}
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}
              >
                Partner Type
              </Typography>
              <Select
                size="small"
                value={partnerType1}
                onChange={(e) => {
                  handlePartnerType(e);
                  setActiveStep(0);
                }}
                sx={{
                  minWidth: 220,
                  mt: 0.5,
                  fontSize: 14,
                  fontWeight: 700,
                  color: '#1e293b',
                  borderRadius: '8px',
                  bgcolor: '#fff'
                }}
              >
                <MenuItem value=" " disabled>
                  Select Partner Type
                </MenuItem>
                {PartnerStatusDrop?.length > 0 &&
                  PartnerStatusDrop?.map((item) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Box>
          </Box>

          <Box
            sx={{
              px: 2,
              py: 0.75,
              bgcolor: '#f0f9ff',
              border: '1px solid #bae6fd',
              borderRadius: '8px',
              color: '#0369a1',
              fontSize: '13px',
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: '#0284c7'
              }}
            />
            {selectedPartnerTypeLabel} Onboarding
          </Box>
        </Card>

        {/* Stepper Wizard Indicator */}
        <Card
          sx={{
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
            p: { xs: 2, sm: 2.5 },
            mb: 3,
            bgcolor: '#ffffff'
          }}
        >
          <Stepper activeStep={activeStep} alternativeLabel>
            <Step key="step-details" completed={activeStep > 0}>
              <StepLabel
                sx={{
                  '& .MuiStepLabel-label': {
                    fontWeight: activeStep === 0 ? 700 : 500,
                    color: activeStep === 0 ? '#0284c7' : '#64748b',
                    fontSize: '13px'
                  },
                  '& .Mui-active .MuiStepIcon-root': { color: '#0284c7' },
                  '& .Mui-completed .MuiStepIcon-root': { color: '#16a34a' }
                }}
              >
                Step 1: {partnerType1 === 66 ? 'Individual Details' : 'Company Details'}
              </StepLabel>
            </Step>
            <Step key="step-documents" completed={false}>
              <StepLabel
                sx={{
                  '& .MuiStepLabel-label': {
                    fontWeight: activeStep === 1 ? 700 : 500,
                    color: activeStep === 1 ? '#0284c7' : '#64748b',
                    fontSize: '13px'
                  },
                  '& .Mui-active .MuiStepIcon-root': { color: '#0284c7' }
                }}
              >
                Step 2: Upload Documents
              </StepLabel>
            </Step>
          </Stepper>
        </Card>

        <form id="myOnboardingForm" onSubmit={handleReduxSubmit(onSubmit)}>
          {partnerType1 &&
            (partnerType1 === 66 ? (
              <>
                {/* Individual Details */}
                <Card
                  sx={{
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    p: { xs: 2.5, md: 4 },
                    mb: 3,
                    bgcolor: '#ffffff',
                    display: activeStep === 0 ? 'block' : 'none'
                  }}
                >
                  <Box sx={{ mb: 3.5 }}>
                    <Box
                      sx={{
                        display: 'inline-block',
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        px: 2.5,
                        py: 0.8,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)'
                      }}
                    >
                      Individual Details
                    </Box>
                  </Box>
                  <Grid container spacing={2.5}>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="partnerName"
                        label="Full Name"
                        control={control}
                        errors={errors}
                        isRequired
                        fieldCode="NAME"
                        fieldType="ALPHABET"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="fathersName"
                        label="Father Name"
                        control={control}
                        errors={errors}
                        isRequired
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomDate
                        name="dob"
                        label="Date of Birth"
                        control={control}
                        errors={errors}
                        isRequired
                        fieldCode="DATE"
                        fieldType="DATE_FIELD"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 90px',
                          gap: 1.5,
                          alignItems: 'end',
                          width: '100%'
                        }}
                      >
                        <CustomInput
                          name="mobile"
                          label="Mobile"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="MOBILE"
                          fieldType="NUMBER_FIELD"
                          disabled={isMobileVerified}
                        />
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isMobileVerified}
                          sx={{
                            minWidth: '90px',
                            height: '40px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            textTransform: 'none',
                            bgcolor: isMobileVerified
                              ? '#16a34a !important'
                              : verifyMobile
                              ? '#13519d !important'
                              : '#cbd5e1 !important',
                            color: '#fff !important',
                            '&:hover': {
                              bgcolor: isMobileVerified ? '#15803d' : '#0d3d75'
                            }
                          }}
                          onClick={() => handleMobileSend()}
                        >
                          {isMobileVerified ? 'Verified' : 'Verify'}
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 90px',
                          gap: 1.5,
                          alignItems: 'flex-end',
                          width: '100%'
                        }}
                      >
                        <CustomInput
                          name="emailAddress"
                          label="Email"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="EMAIL"
                        />
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isEmailVerified}
                          sx={{
                            minWidth: '90px',
                            height: '40px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            textTransform: 'none',
                            bgcolor: isEmailVerified
                              ? '#16a34a !important'
                              : verifyMail
                              ? '#13519d !important'
                              : '#cbd5e1 !important',
                            color: '#fff !important',
                            '&:hover': {
                              bgcolor: isEmailVerified ? '#15803d' : '#0d3d75'
                            }
                          }}
                          onClick={() => handleEmailSend()}
                        >
                          {isEmailVerified ? 'Verified' : 'Verify'}
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="address"
                        label="Address"
                        control={control}
                        errors={errors}
                        isRequired
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="provinceId"
                        label="State"
                        control={control}
                        errors={errors}
                        options={stateDrop || []}
                        onChange={(event, val, option, reason, details) => {
                          handleGetCity(val);
                        }}
                        isRequired
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="districtId"
                        label="City"
                        control={control}
                        errors={errors}
                        options={CityDrop || []}
                        disabled={!stateSelected}
                        isRequired
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="relationshipManager"
                        label="Relationship manager"
                        control={control}
                        errors={errors}
                        options={
                          ReportingManagerListData.map((user) => ({
                            value: user.userId,
                            label: user.fullName
                          })) || []
                        }
                      />
                    </Grid>
                  </Grid>
                </Card>

                {/* Upload Documents Card */}
                <Card
                  sx={{
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    p: { xs: 2.5, md: 4 },
                    mb: 3,
                    bgcolor: '#ffffff',
                    display: activeStep === 1 ? 'block' : 'none'
                  }}
                >
                  <Box sx={{ mb: 3.5 }}>
                    <Box
                      sx={{
                        display: 'inline-block',
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        px: 2.5,
                        py: 0.8,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)'
                      }}
                    >
                      Upload Documents
                    </Box>
                  </Box>
                  <Grid container spacing={3}>
                    {/* Photo */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          Photo
                        </Typography>
                        <input
                          accept="image/png, image/gif, image/jpeg, application/pdf"
                          id="contained-button-file1"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              setPhotoPreview,
                              setUploadPhoto,
                              setPhotoPreviewtype1
                            )
                          }
                        />
                        <label
                          htmlFor="contained-button-file1"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              handleFileUpload(
                                e,
                                setPhotoPreview,
                                setUploadPhoto,
                                setPhotoPreviewtype1
                              )
                            }
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {photoPreviewtype1 === 'pdf' ? (
                              <Document
                                file={photoPreview}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={photoPreview}
                                alt="Person"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>

                    {/* Aadhar */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          Aadhar Card
                        </Typography>
                        <label
                          htmlFor="contained-button-file2"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(
                                e,
                                setAadharFrontPreview,
                                setUploadImageFileFront,
                                setAadharFrontPreviewtype1
                              )
                            }
                            onClick={() => !isAadharVerified && setAadharModalOpen(true)}
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {aadharFrontPreviewtype1 === 'pdf' ? (
                              <Document
                                file={aadharFrontPreview}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={aadharFrontPreview}
                                alt="Aadhar"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}

                            {isAadharVerified && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  inset: 0,
                                  bgcolor: 'rgba(22, 163, 74, 0.15)',
                                  backdropFilter: 'blur(1px)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#16a34a',
                                  fontWeight: 700,
                                  fontSize: '13px'
                                }}
                              >
                                <CheckCircleIcon sx={{ mr: 0.5 }} /> Verified
                              </Box>
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>

                    {/* PAN Card */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          PAN Card
                        </Typography>
                        <input
                          accept="image/png, image/gif, image/jpeg, application/pdf"
                          id="contained-button-file3"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              setPanPreview,
                              setUploadPanImage,
                              setPanPreviewtype1
                            )
                          }
                        />
                        <label
                          htmlFor={isPanVerified ? 'contained-button-file3' : undefined}
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(e, setPanPreview, setUploadPanImage, setPanPreviewtype1)
                            }
                            onClick={() => !isPanVerified && setPanModalOpen(true)}
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {panPreviewtype1 === 'pdf' ? (
                              <Document
                                file={panPreview}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={panPreview}
                                alt="Pan Card"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}

                            {isPanVerified && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  inset: 0,
                                  bgcolor: 'rgba(22, 163, 74, 0.15)',
                                  backdropFilter: 'blur(1px)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#16a34a',
                                  fontWeight: 700,
                                  fontSize: '13px'
                                }}
                              >
                                <CheckCircleIcon sx={{ mr: 0.5 }} /> Verified
                              </Box>
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>

                    {/* Cancelled Cheque */}
                    <Grid item xs={12} sm={6} md={3}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          Cancelled Cheque
                        </Typography>
                        <input
                          accept="image/png, image/gif, image/jpeg, application/pdf"
                          id="contained-button-file5"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              setChequePreview,
                              setUploadChequeImage,
                              setChequePreviewtype1
                            )
                          }
                        />
                        <label
                          htmlFor="contained-button-file5"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(
                                e,
                                setChequePreview,
                                setUploadChequeImage,
                                setChequePreviewtype1
                              )
                            }
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {chequePreviewtype1 === 'pdf' ? (
                              <Document
                                file={chequePreview}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={chequePreview}
                                alt="Cancel Cheque"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </>
            ) : (
              <>
                {/* Company Details */}
                <Card
                  sx={{
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    p: { xs: 2.5, md: 4 },
                    mb: 3,
                    bgcolor: '#ffffff',
                    display: activeStep === 0 ? 'block' : 'none'
                  }}
                >
                  <Box sx={{ mb: 3.5 }}>
                    <Box
                      sx={{
                        display: 'inline-block',
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        px: 2.5,
                        py: 0.8,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)'
                      }}
                    >
                      Company Details
                    </Box>
                  </Box>
                  <Grid container spacing={2.5}>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="companyName"
                        label="Company Name"
                        control={control}
                        errors={errors}
                        isRequired
                        fieldCode="NAME"
                        fieldType="ALPHABET"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput
                        name="authorisedPersonName"
                        label="Authorised Person Name"
                        control={control}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 90px',
                          gap: 1.5,
                          alignItems: 'end',
                          width: '100%'
                        }}
                      >
                        <CustomInput
                          name="mobile"
                          label="Mobile Number"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="MOBILE"
                          fieldType="NUMBER_FIELD"
                          disabled={isMobileVerified}
                        />
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isMobileVerified}
                          sx={{
                            minWidth: '90px',
                            height: '40px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            textTransform: 'none',
                            bgcolor: isMobileVerified
                              ? '#16a34a !important'
                              : verifyMobile
                              ? '#0284c7 !important'
                              : '#cbd5e1 !important',
                            color: '#fff !important',
                            '&:hover': {
                              bgcolor: isMobileVerified ? '#15803d' : '#0369a1'
                            }
                          }}
                          onClick={() => handleMobileSend()}
                        >
                          {isMobileVerified ? 'Verified' : 'Verify'}
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 90px',
                          gap: 1.5,
                          alignItems: 'flex-end',
                          width: '100%'
                        }}
                      >
                        <CustomInput
                          name="emailAddress"
                          label="Email"
                          control={control}
                          errors={errors}
                          isRequired
                          fieldCode="EMAIL"
                        />
                        <Button
                          variant="contained"
                          size="small"
                          disabled={isEmailVerified}
                          sx={{
                            minWidth: '90px',
                            height: '40px',
                            borderRadius: '8px',
                            fontWeight: 600,
                            textTransform: 'none',
                            bgcolor: isEmailVerified
                              ? '#16a34a !important'
                              : verifyMail
                              ? '#0284c7 !important'
                              : '#cbd5e1 !important',
                            color: '#fff !important',
                            '&:hover': {
                              bgcolor: isEmailVerified ? '#15803d' : '#0369a1'
                            }
                          }}
                          onClick={() => handleEmailSend()}
                        >
                          {isEmailVerified ? 'Verified' : 'Verify'}
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="partnerCompanyTypeId"
                        label="Company Type"
                        control={control}
                        errors={errors}
                        options={PartnerCompanyTypesDrop || []}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomDate
                        name="dateOfIncorporation"
                        label="Date of Incorporation"
                        control={control}
                        fieldCode="DATE"
                        fieldType="DATE_FIELD"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput name="companyGstNumber" label="GST Number" control={control} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput name="companyPanNumber" label="PAN Number" control={control} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomInput name="address" label="Address" control={control} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="provinceId"
                        label="State"
                        control={control}
                        errors={errors}
                        options={stateDrop || []}
                        onChange={(event, val, option, reason, details) => {
                          handleGetCity(val);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CustomSelect
                        name="districtId"
                        label="City"
                        control={control}
                        errors={errors}
                        options={CityDrop || []}
                        disabled={!stateSelected}
                      />
                    </Grid>
                  </Grid>
                </Card>

                {/* Company Documents Card */}
                <Card
                  sx={{
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                    p: { xs: 2.5, md: 4 },
                    mb: 3,
                    bgcolor: '#ffffff',
                    display: activeStep === 1 ? 'block' : 'none'
                  }}
                >
                  <Box sx={{ mb: 3.5 }}>
                    <Box
                      sx={{
                        display: 'inline-block',
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        px: 2.5,
                        py: 0.8,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        letterSpacing: '0.2px',
                        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)'
                      }}
                    >
                      Upload Documents
                    </Box>
                  </Box>
                  <Grid container spacing={3}>
                    {/* GST */}
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          GST Certificate
                        </Typography>
                        <input
                          className="fileInput"
                          id="contained-button-file7"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(e, setGstPreview, setGstImage, setGstPreviewtype1)
                          }
                        />
                        <label
                          htmlFor="contained-button-file7"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(e, setGstPreview, setGstImage, setGstPreviewtype1)
                            }
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {gstPreviewtype1 === 'pdf' ? (
                              <Document
                                file={gstPreview}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={gstPreview}
                                alt="GST Certificate"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>

                    {/* PAN */}
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          PAN Card
                        </Typography>
                        <input
                          accept="image/png, image/gif, image/jpeg, application/pdf"
                          id="contained-button-file9"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              setPanPreview1,
                              setUploadPanImageCompany,
                              setPanPreview1type1
                            )
                          }
                        />
                        <label
                          htmlFor="contained-button-file9"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(
                                e,
                                setPanPreview1,
                                setUploadPanImageCompany,
                                setPanPreview1type1
                              )
                            }
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {panPreview1type1 === 'pdf' ? (
                              <Document
                                file={panPreview1}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={panPreview1}
                                alt="Pan Card"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>

                    {/* Cancelled Cheque */}
                    <Grid item xs={12} sm={6} md={4}>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          bgcolor: '#f8fafc',
                          textAlign: 'center'
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                        >
                          Cancelled Cheque
                        </Typography>
                        <input
                          accept="image/png, image/gif, image/jpeg, application/pdf"
                          id="contained-button-file10"
                          multiple
                          type="file"
                          style={{ display: 'none' }}
                          onChange={(e) =>
                            handleFileUpload(
                              e,
                              setChequePreview1,
                              setUploadChequeCompany,
                              setChequePreview1type1
                            )
                          }
                        />
                        <label
                          htmlFor="contained-button-file10"
                          style={{ cursor: 'pointer', display: 'block' }}
                        >
                          <Box
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={(e) =>
                              fileDrop(
                                e,
                                setChequePreview1,
                                setUploadChequeCompany,
                                setChequePreview1type1
                              )
                            }
                            sx={{
                              height: 180,
                              borderRadius: '10px',
                              border: '1.5px dashed #cbd5e1',
                              bgcolor: '#fff',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              overflow: 'hidden',
                              position: 'relative',
                              transition: 'all 0.2s ease-in-out',
                              '&:hover': { borderColor: '#13519d', bgcolor: '#f0f7ff' }
                            }}
                          >
                            {chequePreview1type1 === 'pdf' ? (
                              <Document
                                file={chequePreview1}
                                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                              >
                                <Pages pageNumber={pageNumber} />
                              </Document>
                            ) : (
                              <img
                                src={chequePreview1}
                                alt="Cancel Cheque"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                              />
                            )}
                          </Box>
                        </label>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </>
            ))}
        </form>

        {/* Wizard Action Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: activeStep === 0 ? 'flex-end' : 'space-between',
            alignItems: 'center',
            mt: 3,
            mb: 4
          }}
        >
          {activeStep > 0 && (
            <Button
              variant="outlined"
              onClick={() => {
                setActiveStep(0);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              startIcon={<ArrowBackIcon />}
              sx={{
                borderRadius: '10px',
                borderColor: '#cbd5e1',
                color: '#475569',
                px: 3,
                py: 1,
                fontSize: '13.5px',
                fontWeight: 600,
                textTransform: 'none',
                bgcolor: '#ffffff',
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f8fafc' }
              }}
            >
              Previous
            </Button>
          )}

          {activeStep === 0 ? (
            <Button
              variant="contained"
              onClick={handleNextStep}
              endIcon={<ArrowForwardIcon />}
              sx={{
                bgcolor: '#0284c7',
                color: '#fff',
                px: 4,
                py: 1.1,
                borderRadius: '10px',
                fontSize: '13.5px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              Next: Upload Documents
            </Button>
          ) : (
            <Button
              type="submit"
              form="myOnboardingForm"
              variant="contained"
              disabled={!(isEmailVerified && isMobileVerified)}
              sx={{
                bgcolor: '#0284c7',
                color: '#fff',
                px: 4,
                py: 1.1,
                borderRadius: '10px',
                fontSize: '13.5px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' },
                '&:disabled': { bgcolor: '#cbd5e1', color: '#94a3b8' }
              }}
            >
              Save Partner
            </Button>
          )}
        </Box>
        <ErrorDialog errorOpen={errorOpen} setErrorOpen={setErrorOpen} />

        {/* Email OTP Dialog */}
        <Dialog
          open={otpOpen}
          onClose={() => setOtpOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              fontWeight: 700,
              fontSize: 16,
              color: '#1e293b',
              py: 2,
              px: 3
            }}
          >
            OTP Verification
            <IconButton size="small" onClick={() => setOtpOpen(false)} sx={{ color: '#64748b' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 3, mt: 1 }}>
            <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
              Please enter the OTP sent to your email address: <b>{emailAddress}</b>
            </Typography>
            <CustomInput
              name="otp"
              label="Enter OTP"
              control={control}
              errors={errors}
              value={otpValue}
              onChange={(e) => setOtpValue(e.target.value)}
              fieldCode="NUMBER_FIELD"
              fieldType="NUMBER_FIELD"
            />
          </DialogContent>

          <DialogActions
            sx={{ p: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOtpOpen(false);
                setOtpValue('');
              }}
              sx={{
                borderRadius: '8px',
                borderColor: '#cbd5e1',
                color: '#475569',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handleEmailVerifyOtp()}
              disabled={otpLoading || !otpValue}
              sx={{
                borderRadius: '10px',
                bgcolor: '#0284c7',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              {otpLoading ? 'Verifying...' : 'Verify OTP'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Mobile OTP Dialog */}
        <Dialog
          open={otpMobileOpen}
          onClose={() => setOtpMobileOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              fontWeight: 700,
              fontSize: 16,
              color: '#1e293b',
              py: 2,
              px: 3
            }}
          >
            Mobile OTP Verification
            <IconButton
              size="small"
              onClick={() => setOtpMobileOpen(false)}
              sx={{ color: '#64748b' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 3, mt: 1 }}>
            <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
              Please enter the OTP sent to your mobile number: <b>{mobile}</b>
            </Typography>
            <CustomInput
              name="otp"
              label="Enter OTP"
              control={control}
              errors={errors}
              value={otpMobileValue}
              onChange={(e) => setOtpMobileValue(e.target.value)}
              fieldCode="NUMBER_FIELD"
              fieldType="NUMBER_FIELD"
            />
          </DialogContent>

          <DialogActions
            sx={{ p: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setOtpMobileOpen(false);
                setOtpMobileValue('');
              }}
              sx={{
                borderRadius: '10px',
                borderColor: '#cbd5e1',
                color: '#475569',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handleMobileVerifyOtp()}
              disabled={otpLoading || !otpMobileValue}
              sx={{
                borderRadius: '10px',
                bgcolor: '#0284c7',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              {otpLoading ? 'Verifying...' : 'Verify OTP'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Aadhar Verification Modal */}
        <Dialog
          open={aadharModalOpen}
          onClose={() => {
            setAadharModalOpen(false);
            setAadharNumber('');
            setAadharOtpValue('');
            setOtpGenerated(false);
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              fontWeight: 700,
              fontSize: 16,
              color: '#1e293b',
              py: 2,
              px: 3
            }}
          >
            Verify Aadhar
            <IconButton
              size="small"
              onClick={() => {
                setAadharModalOpen(false);
                setAadharNumber('');
                setAadharOtpValue('');
                setOtpGenerated(false);
              }}
              sx={{ color: '#64748b' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 3, pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                  Upload Aadhar Document
                </Typography>

                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  id="aadhar-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      setAadharFrontPreview,
                      setUploadImageFileFront,
                      setAadharFrontPreviewtype1
                    )
                  }
                />

                <label
                  htmlFor="aadhar-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '1.5px dashed #cbd5e1',
                      borderRadius: '12px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f8fafc',
                      minHeight: '180px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        backgroundColor: '#f0f7ff',
                        borderColor: '#0284c7'
                      }
                    }}
                  >
                    {aadharFrontPreviewtype1 === 'pdf' ? (
                      <Document
                        file={aadharFrontPreview}
                        onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                      >
                        <Pages pageNumber={pageNumber} />
                      </Document>
                    ) : aadharFrontPreview !== aadharFrontDummy ? (
                      <img
                        src={aadharFrontPreview}
                        alt="Aadhar Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '160px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography
                          variant="body2"
                          sx={{ color: '#475569', fontWeight: 600, mb: 0.5 }}
                        >
                          Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: Aadhar Number Input */}
              {uploadImageFileFront && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                    Enter Aadhar Number
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    label="Aadhar Number"
                    value={aadharNumber}
                    onChange={(e) =>
                      setAadharNumber(e.target.value.replace(/\D/g, '').slice(0, 12))
                    }
                    placeholder="Enter 12-digit Aadhar number"
                    variant="outlined"
                    inputProps={{
                      maxLength: 12,
                      pattern: '[0-9]{12}'
                    }}
                    helperText={`${aadharNumber.length}/12 digits`}
                  />
                </Box>
              )}

              {/* Step 3: OTP Input */}
              {otpGenerated && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                    Enter OTP
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', mb: 1.5 }}>
                    OTP has been sent to your registered mobile number
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    label="OTP"
                    value={aadharOtpValue}
                    onChange={(e) =>
                      setAadharOtpValue(e.target.value.replace(/\D/g, '').slice(0, 6))
                    }
                    placeholder="Enter 6-digit OTP"
                    variant="outlined"
                    inputProps={{
                      maxLength: 6,
                      pattern: '[0-9]{6}'
                    }}
                    helperText={`${aadharOtpValue.length}/6 digits`}
                  />
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions
            sx={{ p: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setAadharModalOpen(false);
                setAadharNumber('');
                setAadharOtpValue('');
                setOtpGenerated(false);
              }}
              sx={{
                borderRadius: '10px',
                borderColor: '#cbd5e1',
                color: '#475569',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
              }}
            >
              Close
            </Button>

            {uploadImageFileFront && !otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharSend()}
                disabled={aadharOtpLoading || !aadharNumber || aadharNumber.length < 12}
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#0284c7',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                  '&:hover': { bgcolor: '#0369a1' }
                }}
              >
                {aadharOtpLoading ? 'Sending...' : 'Send OTP'}
              </Button>
            )}

            {otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharVerifyOtp()}
                disabled={aadharOtpLoading || !aadharOtpValue || aadharOtpValue.length < 6}
                sx={{
                  borderRadius: '10px',
                  bgcolor: '#0284c7',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                  '&:hover': { bgcolor: '#0369a1' }
                }}
              >
                {aadharOtpLoading ? 'Verifying...' : 'Verify'}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* PAN Verification Modal */}
        <Dialog
          open={panModalOpen}
          onClose={() => {
            setPanModalOpen(false);
            setPanNumber('');
            setPanName('');
            setPanDob('');
            setUploadPanForVerification(null);
            setPanPreviewForVerification('');
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              fontWeight: 700,
              fontSize: 16,
              color: '#1e293b',
              py: 2,
              px: 3
            }}
          >
            Verify PAN Card
            <IconButton
              size="small"
              onClick={() => {
                setPanModalOpen(false);
                setPanNumber('');
                setPanName('');
                setPanDob('');
                setUploadPanForVerification(null);
                setPanPreviewForVerification('');
              }}
              sx={{ color: '#64748b' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 3, pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                  Upload PAN Document
                </Typography>

                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  id="pan-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setUploadPanForVerification(e.target.files[0]);
                      const reader = new FileReader();
                      reader.onload = (event) => setPanPreviewForVerification(event.target.result);
                      reader.readAsDataURL(e.target.files[0]);
                    }
                  }}
                />

                <label
                  htmlFor="pan-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '1.5px dashed #cbd5e1',
                      borderRadius: '12px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f8fafc',
                      minHeight: '180px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        backgroundColor: '#f0f7ff',
                        borderColor: '#0284c7'
                      }
                    }}
                  >
                    {uploadPanForVerification ? (
                      <img
                        src={panPreviewForVerification}
                        alt="PAN Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '160px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography
                          variant="body2"
                          sx={{ color: '#475569', fontWeight: 600, mb: 0.5 }}
                        >
                          Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: PAN Number Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                  PAN Number
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="PAN Number"
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value.toUpperCase().slice(0, 10))}
                  placeholder="Enter 10-character PAN (e.g., ABCDE1234F)"
                  variant="outlined"
                  inputProps={{
                    maxLength: 10
                  }}
                  helperText={`${panNumber.length}/10 characters`}
                />
              </Box>

              {/* Step 3: Full Name Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                  Full Name (as per PAN)
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  label="Full Name"
                  value={panName}
                  onChange={(e) => setPanName(e.target.value)}
                  placeholder="Enter full name (as per PAN)"
                  variant="outlined"
                />
              </Box>

              {/* Step 4: Date of Birth Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#475569' }}>
                  Date of Birth
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="DOB"
                  value={panDob}
                  onChange={(e) => setPanDob(e.target.value)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Box>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{ p: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                setPanModalOpen(false);
                setPanNumber('');
                setPanName('');
                setPanDob('');
                setUploadPanForVerification(null);
                setPanPreviewForVerification('');
              }}
              sx={{
                borderRadius: '10px',
                borderColor: '#cbd5e1',
                color: '#475569',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handlePanVerify()}
              disabled={
                panVerificationLoading ||
                !panNumber ||
                panNumber.length < 10 ||
                !panName ||
                !panDob ||
                !uploadPanForVerification
              }
              sx={{
                borderRadius: '10px',
                bgcolor: '#0284c7',
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              {panVerificationLoading ? 'Verifying...' : 'Verify PAN'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
export default AddEditOnBoarding;
